import { defineMessages } from 'react-intl';

import {
  ALERT_RESOURCE_TYPES,
  ALERT_STATUSES,
  ALERT_TYPES,
} from '@didaskill/domain/alerts/constants';

export const alertTypesMessages = defineMessages<ALERT_TYPES>({
  [ALERT_TYPES.BROKEN_LINK]: {
    defaultMessage: 'Lien cassé',
  },
});

export const alertStatusesMessages = defineMessages<ALERT_STATUSES>({
  [ALERT_STATUSES.OPEN]: {
    defaultMessage: 'Ouvert',
  },
  [ALERT_STATUSES.IN_PROGRESS]: {
    defaultMessage: 'En cours',
  },
  [ALERT_STATUSES.RESOLVED]: {
    defaultMessage: 'Résolu',
  },
  [ALERT_STATUSES.CANCELLED]: {
    defaultMessage: 'Annulé',
  },
});

export const alertResourceTypesMessages = defineMessages<ALERT_RESOURCE_TYPES>({
  [ALERT_RESOURCE_TYPES.LEARNING_RESOURCE]: {
    defaultMessage: 'Ressource',
  },
  [ALERT_RESOURCE_TYPES.SEQUENCE]: {
    defaultMessage: 'Séquence',
  },
});
